import { render, staticRenderFns } from "./BotaoWhatsapp.vue?vue&type=template&id=2d62e8cd&scoped=true"
import script from "./BotaoWhatsapp.vue?vue&type=script&lang=js"
export * from "./BotaoWhatsapp.vue?vue&type=script&lang=js"
import style0 from "./BotaoWhatsapp.vue?vue&type=style&index=0&id=2d62e8cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d62e8cd",
  null
  
)

export default component.exports